import _ from 'lodash';
import request from 'superagent';
import url from '../../utils/url';
import * as types from '../actionTypes/reportsTabActionTypes';
import * as errorConstants from '../actionTypes/errorActionTypes';


function removeFalsyValues(obj) {
  return _.pickBy(obj, _.identity);
}

function requestReports() {
  return {
    type: types.REQUEST_REPORTS,
  };
}

function requestAutomateMailing() {
  return {
    type: types.REQUEST_AUTOMATE_MAILING_REPORTS,
  };
}

function receiveReports(resBody) {
  return {
    type: types.RECEIVE_REPORTS,
    resBody,
  };
}

function receiveAutomateMailing(resBody) {
  return {
    type: types.RECEIVE_AUTOMATE_MAILING_REPORTS,
    resBody,
  };
}

function receiveError(res, type) {
  let error;
  try {
    error = res.response.body.errors;
  } catch (e) {
    error = `Server error: ${res.status}: ${res.message}`;
  }
  return { type, error };
}

function onSuccessReceiveReports(dispatch) {
  return function (res) {
    return dispatch(receiveReports(res.body));
  };
}

function onSuccessAutomateMailing(dispatch) {
  return function (res) {
    return dispatch(receiveAutomateMailing(res.body));
  };
}

function onFailure(dispatch) {
  return function (res) {
    return dispatch(receiveError(res, errorConstants.SERVER_ERROR));
  };
}

export const reports = params => function (dispatch) {
  dispatch(requestReports());
  const filters = removeFalsyValues(params);

  return request
    .post(url('/localsearch/search-json'))
    .send(filters)
    .set('Content-Type', 'application/json')
    .then(onSuccessReceiveReports(dispatch), onFailure(dispatch));
};

export const automateMailing = params => function (dispatch) {
  dispatch(requestAutomateMailing());

  const filters = removeFalsyValues(params);

  return request
    .post(url('/localsearch/add-alert'))
    .send(filters)
    .set('Content-Type', 'application/json')
    .then(onSuccessAutomateMailing(dispatch), onFailure(dispatch));
};



// WEBPACK FOOTER //
// ./src/redux/actions/reportsTabAction.js